import { render } from "./GiftListView.vue?vue&type=template&id=e3406b2a"
import script from "./GiftListView.vue?vue&type=script&lang=js"
export * from "./GiftListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__